/* Bull Ring Fabrics: the glass-header bag popup (#brf-hc-bag, built by brf-c-header.js) shows clearly that there is more
   below. Added 2026-10-23 for Abid. Loaded from snippets/brf-bag-aurora.liquid; styles in brf-mc-apple.css ("glass header bag").
   - The list is as tall as the screen allows, and is cut through the middle of an item so you can see one peeking out.
   - Soft fades at the top/bottom edges while there is more to scroll.
   - A frosted "↓ 7 more items" pill floats at the bottom of the list; tap it to glide down. It counts down as you scroll.
   - Rows drift in one after another as the bag opens.
   - Changing a quantity keeps the list exactly where it was (2026-10-23 fix: it used to jump after the popup was rebuilt).
   - Bin (2026-10-23, Abid): at quantity 1 the minus becomes a bin that removes the item; the separate bin beside the
     quantity pill only shows when there are more than 4, so a long length can still go in one tap.
   - The close button is a round frosted button with a drawn cross, centred on the "My bag" line (2026-10-23).
   - Stock (2026-10-23, Abid): the quantity pill looks like the bag page's (white, thin warm border) and you can type a
     number into it. + stops at the stock we have (it dims; pressing it again gives a little shake and says so) and typed
     numbers above the stock are brought down to it, so the theme's "Only 4 items were added" message no longer shows.
     Lines with fewer than 10 left say "Only 4 metres left" with a softly pulsing dot. Stock comes from
     sections/brf-cart-max.liquid (same as the bag page).
   - Numbers only (2026-10-23, Abid): every quantity box on the site (product page, quick view, product cards, bag page,
     mini bag and this popup) only takes digits; letters, dots, minus signs and pasted text are kept out. */
(function () {
  if (window.__brfBagMore) return; window.__brfBagMore = 1;
  var doc = document;

  var BIN = '<svg class="brf-hc-bin__ic" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 3.8h4"/><path d="M6.5 7l.8 11.6a2 2 0 0 0 2 1.9h5.4a2 2 0 0 0 2-1.9L17.5 7"/><path d="M10.2 11v5.5M13.8 11v5.5"/></svg>';
  function css() {
    if (doc.getElementById('brf-hc-bin-css')) return;
    var st = doc.createElement('style'); st.id = 'brf-hc-bin-css';
    st.textContent = 'html body .brf-hc__bag-li:not(.brf-hc-many) .brf-hc__bag-rm{display:none!important}'
      + 'html body .brf-hc__bag-q button.brf-hc-bin{display:inline-grid;place-items:center;opacity:1!important;cursor:pointer;color:#1D1D1F;transition:color .2s ease}'
      + 'html body .brf-hc__bag-q button.brf-hc-bin:hover,html body .brf-hc__bag-q button.brf-hc-bin:focus-visible{color:#B3261E}'
      + 'html body .brf-hc-bin__ic{display:block;width:15px;height:15px}'
      /* close button: a round frosted button centred on the "My bag" line, same 16px edge as the rest, a crisp drawn cross */
      + 'html body .brf-hc__bag .brf-hc__bag-h{align-items:center!important}'
      + 'html body .brf-hc__bag .brf-hc__bag-x{position:relative;flex:0 0 auto;width:30px!important;height:30px!important;margin:0 -5px 0 12px!important;padding:0!important;border:0!important;border-radius:50%!important;'
      + 'font-size:0!important;line-height:0!important;color:#1D1D1F!important;cursor:pointer;background:rgba(29,29,31,.06)!important;box-shadow:inset 0 0 0 .5px rgba(29,29,31,.08)!important;'
      + 'transition:background-color .2s ease,transform .3s cubic-bezier(.3,1.5,.4,1)}'
      + 'html body .brf-hc__bag .brf-hc__bag-x::before,html body .brf-hc__bag .brf-hc__bag-x::after{content:"";position:absolute;left:50%;top:50%;width:12px;height:1.8px;margin:-.9px 0 0 -6px;border-radius:2px;background:currentColor;transform:rotate(45deg)}'
      + 'html body .brf-hc__bag .brf-hc__bag-x::after{transform:rotate(-45deg)}'
      + 'html body .brf-hc__bag .brf-hc__bag-x:hover{background:rgba(29,29,31,.11)!important;transform:rotate(90deg)}'
      + 'html body .brf-hc__bag .brf-hc__bag-x:active{transform:scale(.9)}'
      + 'html body .brf-hc__bag .brf-hc__bag-x:focus-visible{outline:2px solid #0071E3;outline-offset:2px}'
      /* quantity pill, as on the bag page */
      + 'html body .brf-hc__bag .brf-hc__bag-q{display:inline-flex!important;align-items:center;gap:0!important;height:34px!important;padding:0!important;border:1px solid #DDD5C8!important;border-radius:980px!important;'
      + 'background:#fff!important;box-shadow:0 1px 1px rgba(221,213,200,.2)!important;transition:transform .2s ease}'
      + 'html body .brf-hc__bag .brf-hc__bag-q>button{display:inline-grid!important;place-items:center;width:32px!important;height:32px!important;margin:0!important;padding:0!important;border:0!important;border-radius:50%!important;'
      + 'background:transparent!important;color:#1D1D1F!important;font-size:16px!important;line-height:1!important;cursor:pointer;transition:background-color .2s ease,opacity .2s ease,color .2s ease}'
      + 'html body .brf-hc__bag .brf-hc__bag-q>button:hover{background:rgba(29,29,31,.05)!important}'
      + 'html body .brf-hc__bag .brf-hc__bag-q>button:disabled{opacity:.35;cursor:default}'
      + 'html body .brf-hc__bag .brf-hc__bag-q>button.brf-hc-max{opacity:.28!important;cursor:not-allowed}'
      + 'html body .brf-hc__bag .brf-hc__bag-q>button.brf-hc-max:hover{background:transparent!important}'
      + 'html body .brf-hc__bag .brf-hc-qin{width:30px;height:30px;margin:0;padding:0;border:0;border-radius:8px;outline:0;background:transparent;box-shadow:none;'
      + 'text-align:center;font:600 14.5px/1 inherit;color:#1D1D1F;-webkit-text-fill-color:#1D1D1F;font-variant-numeric:tabular-nums;-moz-appearance:textfield;appearance:textfield;transition:background-color .2s ease,box-shadow .2s ease}'
      + 'html body .brf-hc__bag .brf-hc-qin:hover{background:rgba(29,29,31,.04)}'
      + 'html body .brf-hc__bag .brf-hc-qin:focus{background:rgba(20,153,84,.07);box-shadow:0 0 0 2px rgba(20,153,84,.35)}'
      /* stock note under the pill */
      + 'html body .brf-hc__bag .brf-hc-left{display:flex;align-items:center;gap:7px;margin:7px 0 0;font-size:12px;font-weight:600;line-height:1.3;color:#C4343B;animation:brfHcIn .35s ease both}'
      + 'html body .brf-hc__bag .brf-hc-left::before{content:"";flex:0 0 auto;width:6px;height:6px;border-radius:50%;background:currentColor;animation:brfHcDot 2s ease-out infinite}'
      + 'html body .brf-hc__bag .brf-hc-left.is-max{color:#1D1D1F}'
      + 'html body .brf-hc__bag .brf-hc-left.is-max::before{background:#E8A33D;animation:none}'
      + 'html body .brf-hc__bag .brf-hc-left.is-nudge{animation:brfHcNudge .45s cubic-bezier(.3,1.5,.4,1)}'
      + 'html body .brf-hc__bag .brf-hc__bag-q.is-nudge{animation:brfHcNudge .45s cubic-bezier(.3,1.5,.4,1)}'
      + '@keyframes brfHcDot{0%{box-shadow:0 0 0 0 rgba(196,52,59,.45)}70%,100%{box-shadow:0 0 0 6px rgba(196,52,59,0)}}'
      + '@keyframes brfHcIn{from{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}'
      + '@keyframes brfHcNudge{0%,100%{transform:none}20%{transform:translateX(-4px)}40%{transform:translateX(4px)}60%{transform:translateX(-3px)}80%{transform:translateX(2px)}}'
      + '@media (prefers-reduced-motion:reduce){html body .brf-hc__bag .brf-hc__bag-x{transition:none}'
      + 'html body .brf-hc__bag .brf-hc-left,html body .brf-hc__bag .brf-hc-left::before,html body .brf-hc__bag .is-nudge{animation:none!important}}';
    doc.head.appendChild(st);
  }
  /* quantity 1: the (disabled) minus becomes an active bin; the header's own click handler then asks for quantity 0 */
  /* ---- stock per popup line: line number -> {vid, max, unit}, from /cart.js + sections/brf-cart-max ---- */
  var stock = { sig: '', byLine: {}, busy: false };
  function cartSig(bag) {
    return [].map.call(bag.querySelectorAll('.brf-hc__bag-li'), function (li) { return li.getAttribute('data-line') + ':' + li.getAttribute('data-q'); }).join(',');
  }
  function loadStock(bag) {
    var sig = cartSig(bag); if (!sig || sig === stock.sig || stock.busy) return;
    stock.busy = true; stock.sig = sig;
    Promise.all([
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/?section_id=brf-cart-max', { credentials: 'same-origin' }).then(function (r) { return r.text(); })
    ]).then(function (res) {
      var c = res[0] || {}, h = res[1] || '', max = {}, unit = {}, by = {};
      var mm = /<script[^>]*data-brf-cart-max[^>]*>([\s\S]*?)<\/script>/.exec(h), um = /<script[^>]*data-brf-cart-unit[^>]*>([\s\S]*?)<\/script>/.exec(h);
      try { max = JSON.parse(mm ? mm[1] : '{}'); } catch (e) { max = {}; }
      try { unit = JSON.parse(um ? um[1] : '{}'); } catch (e) { unit = {}; }
      (c.items || []).forEach(function (it, i) { by[i + 1] = { vid: String(it.variant_id), max: max[it.key] == null ? null : +max[it.key], unit: unit[it.key] || '' }; });
      stock.byLine = by;
    }).catch(function () {}).then(function () {
      stock.busy = false; bins(bag);
      if (cartSig(bag) !== stock.sig) loadStock(bag);
    });
  }
  function infoFor(li) {
    var i = stock.byLine[li.getAttribute('data-line')];
    /* only trust it while the line still holds the same variant (line numbers shift after a removal) */
    return i && li.querySelector('a[href*="variant=' + i.vid + '"]') ? i : null;
  }
  function plural(n, unit) {
    if (unit === 'metre') return n + (n === 1 ? ' metre' : ' metres');
    if (unit === 'roll') return n + (n === 1 ? ' roll' : ' rolls');
    return String(n);
  }
  function noteText(q, max, unit) {
    if (q >= max) return max === 1 ? 'You’ve got the last one' : 'That’s all ' + plural(max, unit) + ' we have';
    return max === 1 ? 'Last one in stock' : 'Only ' + plural(max, unit) + ' left';
  }
  function nudge(li) {
    li.__brfNudge = Date.now(); bins(li.closest('.brf-hc__bag') || doc);
    [li.querySelector('.brf-hc-left'), li.querySelector('.brf-hc__bag-q')].forEach(function (el) {
      if (!el) return; el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge');
    });
  }

  function bins(bag) {
    [].forEach.call(bag.querySelectorAll('.brf-hc__bag-li'), function (li) {
      var q = parseInt(li.getAttribute('data-q'), 10) || 0, minus = li.querySelector('.brf-hc__bag-q [data-bq="-1"]');
      var many = q > 4; if (li.classList.contains('brf-hc-many') !== many) li.classList.toggle('brf-hc-many', many);
      /* the quantity becomes a box you can type in */
      var span = li.querySelector('.brf-hc__bag-q span[aria-label="Quantity"]');
      if (span) {
        var inp = doc.createElement('input');
        inp.className = 'brf-hc-qin'; inp.type = 'text'; inp.value = q;
        inp.setAttribute('inputmode', 'numeric'); inp.setAttribute('pattern', '[0-9]*'); inp.setAttribute('autocomplete', 'off'); inp.setAttribute('aria-label', 'Quantity');
        span.parentNode.replaceChild(inp, span);
      }
      var info = infoFor(li), max = info ? info.max : null, qin = li.querySelector('.brf-hc-qin');
      if (qin) { var mx = max == null ? '' : String(max); if (qin.getAttribute('data-max') !== mx) qin.setAttribute('data-max', mx); }
      /* + stops at the stock we have */
      var plus = li.querySelector('.brf-hc__bag-q [data-bq="1"]'), atMax = max != null && q >= max;
      if (plus && plus.classList.contains('brf-hc-max') !== atMax) {
        plus.classList.toggle('brf-hc-max', atMax);
        if (atMax) { plus.setAttribute('aria-disabled', 'true'); plus.setAttribute('title', 'That’s all we have in stock'); }
        else { plus.removeAttribute('aria-disabled'); plus.removeAttribute('title'); }
      }
      /* "Only 4 metres left" under the pill when fewer than 10 are left (or right after + was pressed at the limit) */
      var note = li.querySelector('.brf-hc-left'), show = max != null && max > 0 && (max < 10 || (li.__brfNudge && Date.now() - li.__brfNudge < 6000));
      if (show) {
        var t = noteText(q, max, info.unit);
        if (!note) {
          note = doc.createElement('span'); note.className = 'brf-hc-left'; note.setAttribute('role', 'status');
          var ctl = li.querySelector('.brf-hc__bag-ctl'); if (ctl) ctl.parentNode.insertBefore(note, ctl.nextSibling); else li.appendChild(note);
        }
        if (note.textContent !== t) note.textContent = t;
        if (note.classList.contains('is-max') !== atMax) note.classList.toggle('is-max', atMax);
      } else if (note) note.parentNode.removeChild(note);
      if (!minus) return;
      var one = q === 1, isBin = minus.classList.contains('brf-hc-bin');
      if (one && !isBin) {
        minus.disabled = false; minus.removeAttribute('disabled'); minus.classList.add('brf-hc-bin');
        minus.innerHTML = BIN; minus.setAttribute('aria-label', 'Remove from bag'); minus.setAttribute('title', 'Remove from bag');
      } else if (!one && isBin) {
        minus.classList.remove('brf-hc-bin'); minus.textContent = '−'; minus.setAttribute('aria-label', 'One less'); minus.removeAttribute('title');
      }
    });
  }

  function setup(bag) {
    if (bag.__brfMore) return; bag.__brfMore = 1;
    css(); bins(bag);

    /* + at the stock limit: no request, just a little shake and the note */
    bag.addEventListener('click', function (e) {
      var p = e.target.closest && e.target.closest('.brf-hc__bag-q [data-bq="1"].brf-hc-max');
      if (!p) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var li = p.closest('.brf-hc__bag-li'); if (li) nudge(li);
    }, true);
    /* a typed quantity is saved through the header's own +/- handler (a hidden button asking for the difference) */
    function commit(inp) {
      var li = inp.closest('.brf-hc__bag-li'); if (!li) return;
      var q0 = parseInt(li.getAttribute('data-q'), 10) || 0, v = parseInt(String(inp.value || '').replace(/\D/g, ''), 10);
      if (isNaN(v)) { inp.value = q0; return; }
      var mx = parseInt(inp.getAttribute('data-max'), 10);
      if (!isNaN(mx) && v > mx) { v = mx; inp.value = v; nudge(li); }
      if (v === q0 || inp.__brfSent === v) return;
      inp.__brfSent = v;
      var b = doc.createElement('button'); b.type = 'button'; b.hidden = true;
      b.setAttribute('data-bq', v === 0 ? '0' : String(v - q0));
      li.appendChild(b); b.click(); if (b.parentNode) b.parentNode.removeChild(b);
    }
    bag.addEventListener('keydown', function (e) {
      if (!e.target.classList || !e.target.classList.contains('brf-hc-qin')) return;
      if (e.key === 'Enter') { e.preventDefault(); commit(e.target); }
      else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        var li = e.target.closest('.brf-hc__bag-li'), btn = li && li.querySelector('.brf-hc__bag-q [data-bq="' + (e.key === 'ArrowUp' ? '1' : '-1') + '"]');
        if (btn && !btn.disabled) btn.click();
      }
    }, true);
    bag.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('brf-hc-qin')) commit(e.target); }, true);
    bag.addEventListener('focusin', function (e) { if (e.target.classList && e.target.classList.contains('brf-hc-qin')) { try { e.target.select(); } catch (x) {} } });
    /* keep the popup open while a quantity is being typed, even if the mouse wanders off it */
    bag.addEventListener('mouseleave', function () {
      var a = doc.activeElement;
      if (a && a.classList && a.classList.contains('brf-hc-qin') && bag.contains(a)) {
        try { bag.dispatchEvent(new MouseEvent('mouseenter')); } catch (x) {}
      }
    });
    var pill = doc.createElement('button');
    pill.type = 'button'; pill.className = 'brf-bagmore'; pill.hidden = true; pill.setAttribute('data-brf-bagmore', '');
    pill.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true"><path d="M6 2v8M2.5 6.5 6 10l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
    bag.appendChild(pill);
    var label = pill.querySelector('span');

    pill.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var L = list(); if (L) L.scrollBy({ top: Math.round(L.clientHeight * 0.8), behavior: 'smooth' });
    });
    function list() { return bag.querySelector('.brf-hc__bag-list'); }

    /* height: as much as fits, ending halfway through a row when the list is longer than that */
    function fit() {
      var L = list(); if (!L || !L.children.length || !bag.classList.contains('is-open')) return;
      /* measure without un-capping the list (that reset the scroll position to the top on every wheel turn) */
      var h = L.children[0].offsetHeight; if (!h) return;
      var lr = L.getBoundingClientRect(), br = bag.getBoundingClientRect();
      var below = br.bottom - lr.bottom;                      /* delivery bar, subtotal and buttons */
      var avail = window.innerHeight - lr.top - below - 18;
      if (L.scrollHeight <= avail) { setMax(L, 'none'); return; }
      var k = Math.max(1, Math.floor((avail - h * 0.5) / h));
      setMax(L, Math.round((k + 0.5) * h + 2) + 'px');
    }
    function setMax(L, v) { lastMax = v; if (L.style.maxHeight !== v) L.style.maxHeight = v; }

    function update() {
      if (!pill.isConnected) bag.appendChild(pill);           /* the header script rebuilds the popup's contents */
      var L = list();
      if (!L) { if (!pill.hidden) pill.hidden = true; return; }
      var left = L.scrollHeight - L.clientHeight - L.scrollTop, more = left > 4;
      if (L.classList.contains('is-more') !== more) L.classList.toggle('is-more', more);
      var scrolled = L.scrollTop > 4;
      if (L.classList.contains('is-scrolled') !== scrolled) L.classList.toggle('is-scrolled', scrolled);
      if (!more) { if (!pill.hidden) pill.hidden = true; return; }
      var bottom = L.getBoundingClientRect().bottom, n = 0;
      [].forEach.call(L.children, function (r) { if (r.getBoundingClientRect().top + r.offsetHeight * 0.55 > bottom) n++; });
      var t = n ? n + ' more item' + (n > 1 ? 's' : '') : 'More below';
      if (label.textContent !== t) label.textContent = t;
      var top = (L.offsetTop + L.clientHeight - 46) + 'px';
      if (pill.style.top !== top) pill.style.top = top;
      if (pill.hidden) pill.hidden = false;
    }

    var raf = 0, raf2 = 0, wasOpen = false, lastList = null, lastMax = '', lastTop = 0;
    /* Changing a quantity makes the header script rebuild the whole popup. Carry the fitted height, the scroll position and
       the fades over to the new list straight away (before it paints), so the rows don't jump. Programmatic scrolls on the list
       are made instant; the pill still glides because it asks for a smooth scroll itself. */
    function adopt() {
      var L = list(); if (!L || L === lastList) return;
      var had = !!lastList; lastList = L;
      L.style.scrollBehavior = 'auto';
      if (had && bag.classList.contains('is-open')) { if (lastMax) L.style.maxHeight = lastMax; L.scrollTop = lastTop; update(); }
    }
    function soon() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; fit(); update(); }); }
    /* the list scrolling: only the pill and the fades follow; the height is left alone */
    bag.addEventListener('scroll', function (e) {
      if (e.target === lastList) lastTop = lastList.scrollTop;
      if (raf2) return; raf2 = requestAnimationFrame(function () { raf2 = 0; update(); });
    }, true);
    window.addEventListener('resize', soon, { passive: true });
    new MutationObserver(function (recs) {
      var open = bag.classList.contains('is-open');
      if (open && !wasOpen) {
        bag.classList.add('brf-in'); setTimeout(function () { bag.classList.remove('brf-in'); }, 900);
        setTimeout(soon, 380);                                       /* after the opening animation */
      }
      if (!open) { lastTop = 0; }
      wasOpen = open;
      adopt(); bins(bag); if (open) loadStock(bag);
      for (var i = 0; i < recs.length; i++) if (!pill.contains(recs[i].target) && recs[i].target !== pill) { soon(); return; }
    }).observe(bag, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    soon();
  }

  function find() { var b = doc.getElementById('brf-hc-bag'); if (b) { setup(b); return true; } return false; }
  if (!find()) {
    var tries = 0, iv = setInterval(function () { if (find() || ++tries > 40) clearInterval(iv); }, 500);
  }
})();

/* ---- Numbers only in every quantity box on the site (2026-10-23, Abid) ----
   Product page, quick view, product cards, bag page, mini bag and the header bag popup. Typing anything other than a digit
   does nothing; pasted or dropped text keeps only its digits; phones get the number pad. Arrow keys, Backspace, Tab,
   Enter and shortcuts (copy, select all…) still work. */
(function () {
  if (window.__brfQtyNum) return; window.__brfQtyNum = 1;
  var doc = document;
  var SEL = 'input.quantity-selector__value, input[name="quantity"]:not([type="hidden"]), input[name^="updates"], input.brf-qa__in, input.brf-hc-qin';
  function isQ(t) { return t && t.matches && t.matches(SEL); }
  function put(t, digits) {
    if (!digits) return;
    if (t.type === 'number') { t.value = digits; }
    else { try { if (!doc.execCommand('insertText', false, digits)) t.value = digits; } catch (x) { t.value = digits; } }
    t.dispatchEvent(new Event('input', { bubbles: true }));
  }
  doc.addEventListener('focusin', function (e) {
    var t = e.target; if (!isQ(t)) return;
    if (t.getAttribute('inputmode') !== 'numeric') t.setAttribute('inputmode', 'numeric');
    if (t.type !== 'number' && !t.getAttribute('pattern')) t.setAttribute('pattern', '[0-9]*');
  }, true);
  doc.addEventListener('keydown', function (e) {
    if (!isQ(e.target) || e.ctrlKey || e.metaKey || e.altKey) return;
    var k = e.key;
    if (k && k.length === 1 && !/[0-9]/.test(k)) e.preventDefault();
  }, true);
  doc.addEventListener('beforeinput', function (e) {
    if (!isQ(e.target) || e.data == null) return;
    if (/[^0-9]/.test(e.data)) { e.preventDefault(); put(e.target, e.data.replace(/\D/g, '')); }
  }, true);
  doc.addEventListener('paste', function (e) {
    if (!isQ(e.target)) return;
    var txt = ''; try { txt = (e.clipboardData || window.clipboardData).getData('text') || ''; } catch (x) {}
    if (/[^0-9]/.test(txt)) { e.preventDefault(); put(e.target, txt.replace(/\D/g, '')); }
  }, true);
  doc.addEventListener('drop', function (e) {
    if (!isQ(e.target)) return;
    var txt = ''; try { txt = e.dataTransfer.getData('text') || ''; } catch (x) {}
    if (/[^0-9]/.test(txt)) e.preventDefault();
  }, true);
  /* last line of defence (autofill, odd keyboards): strip anything that isn't a digit */
  doc.addEventListener('input', function (e) {
    var t = e.target; if (!isQ(t) || t.type === 'number') return;
    if (/[^0-9]/.test(t.value)) { var p = t.selectionStart; t.value = t.value.replace(/\D/g, ''); try { t.setSelectionRange(Math.max(0, p - 1), Math.max(0, p - 1)); } catch (x) {} }
  }, true);
})();
